import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EmMarkdownPipe} from '@emma-labs/shared/angular';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {ModificationNoticeInfo} from '../../../entities/archived-proposal-object/modification-notice-info';

@Component({
  selector: 'em-modification-notice-section',
  templateUrl: './modification-notice-section.component.html',
  imports: [CardModule, ButtonModule, EmMarkdownPipe],
})
export class ModificationNoticeSectionComponent {
  @Input({required: true}) modificationNoticeInfo!: ModificationNoticeInfo;

  @Output() sendModificationNotice = new EventEmitter<() => void>();

  isLoading = false;

  send(): void {
    this.isLoading = true;

    this.sendModificationNotice.emit(() => (this.isLoading = false));
  }
}
